import styled from 'styled-components';

const PinIconSvg = styled.svg`
  width: 12px;
  height: 12px;
  color: var(--text-secondary);
  flex-shrink: 0;
`;

export default function PinIcon() {
  return (
    <PinIconSvg viewBox="0 0 24 24" fill="none" aria-label="Pinned">
      <path
        d="M19.8011 9.61919C19.9139 9.50626 19.9773 9.35313 19.9773 9.19346C19.9773 9.0338 19.9139 8.88067 19.8011 8.76773L15.2343 4.19872C15.1214 4.08586 14.9682 4.02246 14.8086 4.02246C14.6489 4.02246 14.4958 4.08586 14.3829 4.19872L10.0691 8.52456C10.0691 8.52456 7.97992 7.48037 5.74849 9.28117C5.68232 9.33413 5.62808 9.40047 5.5893 9.47584C5.55053 9.55121 5.5281 9.63391 5.52348 9.71854C5.51886 9.80317 5.53216 9.88783 5.5625 9.96697C5.59284 10.0461 5.63954 10.118 5.69956 10.1778L13.8227 18.3002C13.8836 18.3606 13.9566 18.4073 14.0369 18.4372C14.1173 18.4671 14.2031 18.4796 14.2886 18.4736C14.3741 18.4677 14.4574 18.4436 14.5328 18.4029C14.6083 18.3623 14.6742 18.3059 14.7261 18.2377C15.3578 17.3976 16.35 15.6713 15.4873 13.9465L19.8011 9.61919Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.76036 14.2393L6.12488 17.8747"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </PinIconSvg>
  );
}
